class OptionListController {

    constructor($timeout, $scope, $state, optionsService, messageService, access, $stateParams) {
        this.$scope = $scope;
        this.$state = $state;
        this.optionsService = optionsService;
        this.messageService = messageService;
        this.access = access;
        this.$stateParams = $stateParams;
        $scope.treeOptions = {
            dropped: function (sourceNodeScope) {
                $timeout(() => sourceNodeScope.source.nodesScope.$parent.$parent.$ctrl.saveStructure()
                );
            }
        };
    }

    $onInit () {
        this.filtertext = this.$stateParams.filtertext || null;
        if (this.filtertext) {
            this.isFiltered = true;
        }

        this.activeTab = 'tree';
        this.updatePaging();
        this.$scope.$watch(
            function (scope) {
                return scope.current_page;
            },
            function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.options = undefined;
                        scope.$ctrl.optionsService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
                            scope.$ctrl.options = response;
                            scope.$ctrl.loading = false;
                        });
                    }
                    else {
                        scope.$ctrl.optionsService.findAll(newVal, scope.per_page)
                            .then(list => scope.$ctrl.options = list);
                    }
                }
            }
        );
    }

    updatePaging () {
        this.$scope.per_page = this.options.per_page;
        this.$scope.current_page = this.options.current_page;
        this.$scope.total = this.options.total;
    }

    onDelete (option) {
        this.optionsService.delete(option.id)
            .then(() => {
                this.messageService.success(`The option <strong>${option.name}</strong> was successfully deleted.`);
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(`The option <strong>${option.name}</strong> could not be successfully deleted: ${error.statusText}`);
                this.messageService.push();
            })
            .then(() => {
                let page = this.options.current_page;
                this.options = [];
                this.loading = true;
                return this.optionsService.findAll(page).then(response => {
                    this.options = response;
                    this.loading = false;
                });
            });
    }

    saveStructure () {
        this.optionsService.reconstruct(this.options.tree)
            .catch(() => {
                this.messageService.failure(`This option structure could not be successfully saved: ${error.statusText}`);
                this.messageService.push();
            })
            .then(() => {
                this.messageService.success(`This option structure has been successfully saved.`);
                this.messageService.push();
                this.messageService.autoClear();
            });
    }

    filter () {
        if (!this.loading && this.filtertext) {
            this.startFilter();
            this.optionsService.search(this.filtertype, this.filtertext).then(response => {
                this.isFiltered = true;
                this.endFilter(response);
            });
        }
    }

    clearfilter () {
        if (this.isFiltered) {
            this.startFilter();
            this.optionsService.findAll().then(response => {
                this.isFiltered = false;
                this.endFilter(response);
            });
        }
    }

    filtertypeChange () {
        switch (this.filtertype) {
            case 'status':
                this.filtertext = '1';
                break;
            default:
                this.filtertext = '';
                break;
        }
    }

    startFilter () {
        this.options = undefined;
        this.loading = true;
    }

    endFilter (response) {
        this.options = response;
        this.updatePaging();
        this.loading = false;
    }
}

OptionListController.$inject = ['$timeout', '$scope', '$state', 'optionsService', 'messageService', 'access', '$stateParams'];

export default OptionListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/options.list.controller.js